/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const PermissionDto = {
    MenuEmergencyContacts: 'MENU_EMERGENCY_CONTACTS',
    MenuEmails: 'MENU_EMAILS',
    MenuChats: 'MENU_CHATS',
    MenuCalendar: 'MENU_CALENDAR',
    MenuTasks: 'MENU_TASKS',
    MenuProcesses: 'MENU_PROCESSES',
    MenuStatistics: 'MENU_STATISTICS',
    MenuOffers: 'MENU_OFFERS',
    MenuCatalog: 'MENU_CATALOG',
    MenuContacts: 'MENU_CONTACTS',
    MenuCustomers: 'MENU_CUSTOMERS',
    MenuSuppliers: 'MENU_SUPPLIERS',
    MenuCars: 'MENU_CARS',
    MenuHr: 'MENU_HR',
    MenuDictionaries: 'MENU_DICTIONARIES',
    ViewReports: 'VIEW_REPORTS',
    ManageSettlements: 'MANAGE_SETTLEMENTS',
    MenuUsers: 'MENU_USERS',
    UpdateProcessOwner: 'UPDATE_PROCESS_OWNER',
    UpdateProcess: 'UPDATE_PROCESS',
    EditAllTasks: 'EDIT_ALL_TASKS',
    ReadAllTasks: 'READ_ALL_TASKS',
    EditRelatedTask: 'EDIT_RELATED_TASK',
    ReadRelatedTask: 'READ_RELATED_TASK',
    CreateTask: 'CREATE_TASK',
    ReadUsers: 'READ_USERS',
    EditUsers: 'EDIT_USERS',
    ViewAllCalendarOfferStatuses: 'VIEW_ALL_CALENDAR_OFFER_STATUSES',
    DownloadContactsReport: 'DOWNLOAD_CONTACTS_REPORT',
    UseEmailAiSuggestions: 'USE_EMAIL_AI_SUGGESTIONS',
    FilterProcessesByUpdateDate: 'FILTER_PROCESSES_BY_UPDATE_DATE',
    CreateHiddenTasks: 'CREATE_HIDDEN_TASKS',
    ViewAllCarTodos: 'VIEW_ALL_CAR_TODOS',
    EditAllContacts: 'EDIT_ALL_CONTACTS',
    ResetCatalog: 'RESET_CATALOG',
    PostAnnouncements: 'POST_ANNOUNCEMENTS',
} as const;

export type PermissionDto = typeof PermissionDto[keyof typeof PermissionDto];



